export const globalUrlPrefix = window.location.pathname
